






























































































import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import Activity from '@/components/activity/Activity.vue';
import ActivityStatus from '@/components/activity/ActivityStatusText.vue';
import AccessibleButton from '@/components/ui/AccessibleButton.vue';
import BottomScores from '@/components/activity/BottomScores.vue';
import {
  Phrase,
  QuizPhrase,
  QuizTranslationWord,
  RapidTestResponse,
} from '@/store/types';
import shuffle from 'lodash.shuffle';
import uniqby from 'lodash.uniqby';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  components: {
    activity: Activity,
    'accessible-button': AccessibleButton,
    'activity-status': ActivityStatus,
    'bottom-scores': BottomScores,
  },
  props: {
    videoPlayer: Object as () => any,
    nativePhrasesMode: Boolean,
    quizPhrase: Object as () => QuizPhrase,
    activityIndex: Number,
    activityDataLength: Number,
    averageScore: Number,
    isRapidTest: Boolean,
  },
  data() {
    return {
      timeouts: [],
      answerWords: new Array<QuizTranslationWord>(),
      rapidTestAnswerWords: new Array<QuizTranslationWord>(),
      quizWords: new Array<QuizTranslationWord>(),
      wordPenalty: 0,
      currentWord: 0,
      currentScore: 100,
      quizPhraseCurrent: this.quizPhrase,
      lockInput: false,
      nextQuestionResponse: null as RapidTestResponse | null,
    };
  },
  mounted() {
    this.wordPenalty = 0;
    this.currentScore = 100;
  },
  computed: {
    wordStyle(): string {
      let result = 'padding: 2px; min-width: 30px; text-transform: none; font-size: ';
      result += this.$vuetify.breakpoint.xs ? '18px;' : '24px;';
      return result;
    },
    phraseCompleted(): boolean {
      if (this.isRapidTest) {
        return this.nextQuestionResponse && this.nextQuestionResponse.data?.question;
      }
      return this.currentWord !== 0 && this.currentWord === this.answerWords.length;
    },
    originalPhrases(): Array<Phrase> {
      if (this.isRapidTest) {
        return [];
      }
      if (this.$store.state.personalizedCourse || (this.$store.state.levelDaily
        && this.$store.state.level.id === LearningTools.LEVEL_DAILY_LESSONS)) {
        return this.$store.state.phrases;
      }
      return this.$store.state.phrases.filter((item: Phrase) => item.lesson_id
        === this.$store.state.lesson.id);
    },
  },
  methods: {
    onPhoneticModeChanged() {
      (this.$refs.activity as any).stopActivity();
      (this.$refs.activity as any).setActivityReady(null, false);
    },
    activityReady() {
      this.wordPenalty = 0;
      this.currentScore = 100;
      this.currentWord = 0;
      this.quizWords = [];
      this.answerWords = [];
      if (!this.isRapidTest) {
        this.quizPhraseCurrent = LearningTools.generateTranslationQuiz(this.$store,
          this.quizPhrase.phrase!, this.originalPhrases, this.quizPhrase.quizType);
        this.setupPhrase();
      } else {
        this.setupRapidTestPhrase();
      }
      this.wordPenalty = Math.round(100 / this.quizWords.length);
      (this.$refs.activity as any).startPlaying();
    },
    onActivityStopped() {
      this.currentWord = 0;
      this.quizWords = [];
      this.answerWords = [];
    },
    audioPlayed() {
      if (this.phraseCompleted) {
        this.$emit('checkQuizEndOrNext', this.nextQuestionResponse);
      }
    },
    async onWord(n: number) {
      if (this.phraseCompleted) {
        return;
      }
      BbTools.clearSleep(this.$store);

      if (!this.quizWords[n - 1].clicked) {
        let answerCorrect = this.answerWords[this.currentWord].textToCompare
          === this.quizWords[n - 1].textToCompare;

        if (this.isRapidTest) {
          this.lockInput = true;
          this.nextQuestionResponse = await LearningTools.setAnswerAndGetNextRapidTestPhrase(
            this.$store,
            this.$router,
            this.quizPhrase.quizType,
            this.quizWords[n - 1].text,
          );
          if (!this.nextQuestionResponse) {
            return;
          }
          answerCorrect = this.nextQuestionResponse.next
            || this.nextQuestionResponse.data?.question;
          this.lockInput = false;
        }

        if (answerCorrect) {
          // correct
          this.quizWords[n - 1].clicked = true;
          this.currentWord += 1;
          this.rapidTestAnswerWords.push(this.quizWords[n - 1].text);
          if (this.phraseCompleted) {
            (this.$refs.activity as any).pauseAllAudio();
            this.$emit('onScoreResult', this.currentScore / 100);
            if (this.$refs.activityStatus) {
              (this.$refs.activityStatus as any).updateScore(this.currentScore / 100, '');
            }
            await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store);
            (this.$refs.activity as any).startPlaying();
          }
        } else {
          // incorrect
          const incorrectWord = this.quizWords[n - 1];
          incorrectWord.badge = true;
          (this.$refs.activityStatus as any).updateScore(0, '');
          this.currentScore -= this.wordPenalty;
          if (this.currentScore < 0) {
            this.currentScore = 0;
          }
          setTimeout(() => { incorrectWord.badge = false; }, 500);
        }
      }
    },
    word(n: number) {
      if (n < this.currentWord) {
        if (this.isRapidTest) {
          return this.rapidTestAnswerWords[n];
        }
        return this.answerWords[n].text;
      }
      return this.$vuetify.breakpoint.xs ? '__' : '_____';
    },
    wordClass(n: number) {
      if (n < this.currentWord) {
        return 'success--text';
      }
      return 'link--text';
    },
    setupPhrase() {
      const resultAnswerWordsArray = new Array<QuizTranslationWord>();
      const resultQuizWordsArray = new Array<QuizTranslationWord>();
      const fakeQuizWordsArray = new Array<QuizTranslationWord>();
      this.quizPhraseCurrent.phraseAnswer.forEach((word: string) => {
        const quizWordNoPunctuation = BbTools.replaceAll(word.toLowerCase(), /\.|\?|!/, '');
        resultAnswerWordsArray.push({
          text: word,
          textToCompare: quizWordNoPunctuation,
          clicked: false,
          badge: false,
        });
        resultQuizWordsArray.push({
          text: word,
          textToCompare: quizWordNoPunctuation,
          clicked: false,
          badge: false,
        } as QuizTranslationWord);
      });
      this.quizPhraseCurrent.choicesString.forEach((word: string) => {
        const quizWordNoPunctuation = BbTools.replaceAll(word.toLowerCase(), /\.|\?|!/, '');
        fakeQuizWordsArray.push({
          text: word,
          textToCompare: quizWordNoPunctuation,
          clicked: false,
          badge: false,
        } as QuizTranslationWord);
      });
      this.answerWords = resultAnswerWordsArray;
      const fakeQuizWordsArrayUniq = uniqby(fakeQuizWordsArray, 'textToCompare');
      fakeQuizWordsArrayUniq.forEach((fakeWord) => {
        const wordAlreadyExists = resultQuizWordsArray
          .find((word: QuizTranslationWord) => word.textToCompare === fakeWord.textToCompare);
        if (!wordAlreadyExists) resultQuizWordsArray.push(fakeWord);
      });
      this.quizWords = shuffle(resultQuizWordsArray);
    },
    setupRapidTestPhrase() {
      const resultAnswerWordsArray = [];
      this.quizPhraseCurrent.phraseAnswer.forEach((word: string) => {
        resultAnswerWordsArray.push({
          text: word,
          textToCompare: word,
          clicked: false,
          badge: false,
        });
      });
      this.answerWords = resultAnswerWordsArray;
      const resultQuizWordsArray = [];
      this.quizPhraseCurrent.choicesString.forEach((word: string) => {
        resultQuizWordsArray.push({
          text: word,
          textToCompare: word,
          clicked: false,
          badge: false,
        } as QuizTranslationWord);
      });
      this.quizWords = resultQuizWordsArray;
    },
  },
  beforeDestroy() {
    BbTools.clearSleep(this.$store);
  },
});
